import React from 'react';
import { Button } from 'reactstrap';
import { Link } from 'react-router-dom'
import { connect } from 'react-redux';
import { NotificationManager } from 'react-notifications';
import IntlMessages from 'util/IntlMessages';
import { injectIntl } from 'react-intl';
import {
  hideMessage,
  showAuthLoader,
  userSignIn,
  fetchCompany
} from 'actions/Auth';
import CircularProgress from 'components/CircularProgress'

class SignIn extends React.Component {
  constructor() {
    super();
    this.state = {
      companyCode: '',
      username: '',
      password: ''
    }
  }

  hideLoader() {
    this.props.hideMessage();
  }

  componentDidUpdate() {
    const { showMessage, isLogged } = this.props;
    let { alertMessage } = this.props;

    if (showMessage && !this.props.intl.messages[alertMessage]) {
      alertMessage = 'appModule.serverError';
    }

    if (showMessage) {
      NotificationManager.error(<IntlMessages id={alertMessage} />) 
      this.hideLoader()
    }

    if (isLogged) {
      this.props.fetchCompany();
      this.props.history.push('/');
    }
  }

  onFormSubmit = (e) => {
    e.preventDefault();
    const { companyCode, username, password } = this.state;
    this.props.showAuthLoader();
    this.props.userSignIn({ companyCode, username, password });
  }

  handleInputChange = (e) => {
    e.preventDefault();
    this.setState({
      [e.target.name]: e.target.value,
    });
  }

  render() {
    const { loader, intl } = this.props;
    const placeholderCompanyCode = intl.formatMessage({ id: "appModule.companyCode" });
    const placeholderUsername = intl.formatMessage({ id: "appModule.username" });
    const placeholderPassword = intl.formatMessage({ id: "appModule.password" });

    return (
      <div
        className="app-login-container d-flex justify-content-center align-items-center animated slideInUpTiny animation-duration-3">
        <div className="app-login-main-content">

          <div className="app-logo-content d-flex align-items-center justify-content-center">
            <Link className="logo-lg" to="/" title="iDental">
              <img src="assets/images/iDental.png" alt="iDental" title="iDental" />
            </Link>
          </div>

          <div className="app-login-content">
            <div className="app-login-header mb-4">
              <h1><IntlMessages id="appModule.iDental" /></h1>
            </div>

            <div className="app-login-form">
              <form onSubmit={this.onFormSubmit.bind(this)}>
                <div className="form-group mb-3">
                  <input
                    name="companyCode"
                    placeholder={placeholderCompanyCode}
                    onChange={this.handleInputChange.bind(this)}
                    className="form-control form-control-lg"
                  />
                </div>

                <div className="form-group mb-3">
                  <input
                    name="username"
                    placeholder={placeholderUsername}
                    onChange={this.handleInputChange.bind(this)}
                    className="form-control form-control-lg"
                  />
                </div>

                <div className="form-group mb-3">
                  <input
                    name="password"
                    type="password"
                    placeholder={placeholderPassword}
                    onChange={this.handleInputChange.bind(this)}
                    className="form-control form-control-lg"
                  />
                </div>

                <div className="mb-3 d-flex align-items-center justify-content-between">
                  { loader &&
                    <Button type="submit" color="primary" className="text-uppercase" disabled>
                      <IntlMessages id="appModule.signIn" />
                    </Button>
                  }
                  { !loader &&
                    <Button type="submit" color="primary" className="text-uppercase" >
                      <IntlMessages id="appModule.signIn" />
                    </Button>
                  }
                </div>
              </form>
            </div>
          </div>

        </div>
        { loader &&
          <div className="loader-view">
            <CircularProgress />
          </div>
        }
      </div>
    );
  }
}

const mapStateToProps = ({ auth }) => {
  const { loader, alertMessage, showMessage, isLogged } = auth;
  return { loader, alertMessage, showMessage, isLogged }
};
let injectedIntl = injectIntl(SignIn);

export default connect(mapStateToProps, {
  userSignIn,
  fetchCompany,
  hideMessage,
  showAuthLoader
})(injectedIntl);



// WEBPACK FOOTER //
// ./containers/SignIn.js